function strategyKeyToSlug(strategyKey) {
  return strategyKey
    .replace(/^strategy/, "")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1-$2")
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/([A-Za-z])(\d)/g, "$1-$2")
    .toLowerCase();
}

const SUDOKU_STRATEGIES = {
  strategyFullHouse: {
    name: "Full House",
    link: "/guides/how-to-play",
  },
  strategyNakedSingle: {
    name: "Naked Single",
    link: "/guides/sudoku-candidate-mode",
  },
  strategyHiddenSingle: {
    name: "Hidden Single",
    link: "/guides/last-possible-candidate",
  },
  strategyLockedCandidatesType1: {
    name: "Locked Candidates (Type 1)",
    link: "/guides/Locked-Candidates-or-Box-Column-Row-interactions",
  },
  strategyLockedCandidatesType2: {
    name: "Locked Candidates (Type 2)",
    link: "/guides/Locked-Candidates-or-Box-Column-Row-interactions",
  },
  strategyNakedPair: {
    name: "Naked Pair",
    link: "/guides/Naked-Pairs-Triples-Quads",
  },
  strategyHiddenPair: {
    name: "Hidden Pair",
    link: "/guides/hidden-pairs-technique",
  },
  strategyNakedTriple: {
    name: "Naked Triple",
    link: "/guides/Naked-Pairs-Triples-Quads",
  },
  strategyHiddenTriple: {
    name: "Hidden Triple",
    link: "/guides/hidden-triples",
  },
  strategyNakedQuadruple: {
    name: "Naked Quadruple",
    link: "/guides/Naked-Pairs-Triples-Quads",
  },
  strategyHiddenQuadruple: {
    name: "Hidden Quadruple",
    link: "",
  },
  strategyXWing: {
    name: "X-Wing",
    link: "/guides/X-Wing-technique",
  },
  strategyFinnedXWing: {
    name: "Finned X-Wing",
    link: "",
  },
  strategySwordfish: {
    name: "Swordfish",
    link: "/guides/swordfish-technique",
  },
  strategyJellyfish: {
    name: "Jellyfish",
    link: "/guides/jellyfish-sudoku-technique",
  },
  strategyXYWing: {
    name: "XY-Wing",
    link: "/guides/Finding-Y-Wing-Styles",
  },
  strategyXYZWing: {
    name: "XYZ-Wing",
    link: "/guides/sudoku-advanced-strategies",
  },
  strategySkyscraper: {
    name: "Skyscraper",
    link: "/guides/sudoku-skyscraper",
  },
  strategyTwoStringKite: {
    name: "Two-String Kite",
    link: "",
  },
  strategyWWing: {
    name: "W-Wing",
    link: "/guides/finding-w-wing",
  },
  bruteForce: {
    name: "Brute Force",
    link: "",
  },
};

Object.entries(SUDOKU_STRATEGIES).forEach(([key, strategy]) => {
  if (key !== "bruteForce") {
    strategy.practice = `/practice/${strategyKeyToSlug(key)}`;
  }
  Object.freeze(strategy);
});
Object.freeze(SUDOKU_STRATEGIES);

module.exports = { SUDOKU_STRATEGIES, strategyKeyToSlug };
